import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper.scss';
import CardTopic from '@/components/content-v2/templates/streaming/card-topic';

export default {
  props: {
    topic: {
      type    : Object,
      default : () => ({})
    },
    children: {
      type    : Array,
      default : () => []
    },
    isLastRow: {
      type    : Boolean,
      default : false
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    CardTopic
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView : 'auto',
        spaceBetween  : 0,
        pagination    : {
          el        : '.swiper-pagination',
          clickable : true
        },
        navigation: {
          prevEl : '.carousel__prev-button',
          nextEl : '.carousel__next-button'
        },
        allowTouchMove : window.innerWidth <= 960,
        breakpoints    : {
          max: {
            slidesPerGroup: 1
          },
          425: {
            slidesPerGroup: 1
          },
          600: {
            slidesPerGroup: 2
          },
          960: {
            slidesPerGroup: 3
          },
          1264: {
            slidesPerGroup: 4
          },
          1904: {
            slidesPerGroup: 6
          }
        }
      },
      progress : null,
      hasPages : false
    };
  },
  computed: {
    ...mapGetters({
      getterUserRoleContext: 'plataforma/user/getterUserContext'
    })
  },
  watch: {
    'topic': {
      handler: function(newTopic, oldTopic) {
        newTopic.children.length !== oldTopic.children.length && this.setSwiperPageConfigurations();
      },
      deep: true
    }
  },
  mounted() {
    this.setSwiperPageConfigurations();
  },
  methods: {
    navigation(direction) {
      if (direction === 'left') {
        this.$refs.swiper.$swiper.slidePrev();
      } else {
        this.$refs.swiper.$swiper.slideNext();
      }
    },
    finishedTransition() {
      this.progress = this.$refs.swiper.$swiper.progress;
    },
    onResize() {
      const width = window.innerWidth;
      this.$refs.swiper.$swiper.allowTouchMove = width <= 960;
      this.progress = this.$refs.swiper.$swiper.progress;
    },
    setSwiperPageConfigurations() {
      const totalTopics = this.children.length;
      const totalTopicsPerBreakpoint = this.swiperOptions.breakpoints[this.$refs.swiper.$swiper.currentBreakpoint].slidesPerGroup;

      this.$nextTick(() => {
        this.progress = this.$refs.swiper.$swiper.progress;
        this.hasPages = totalTopics > totalTopicsPerBreakpoint;
      });
    }
  }
};
